// eslint-disable-next-line no-useless-escape
export const IMPORT_LINE_REGEX = /^((?<date>[0-2][0-9]\/[0-1][0-9]\/[1-2][0-9]{3}),(?<description>[\w\s]+),(?<amount>[0-9\-\.]+),?)$/;
export const FIELD_REQUIRED_MSG = 'This field is required';
export const INCORRECT_DATA_FORMAT =
  'Incorrect data format. See `Data formatting requirements` section for help.';
